export const dynamicConfigUrl = 'config.json';

export const defaultConfig = {
  oktaClientId: '0oa1x18egr3MtY5tW1d7',
  oktaIssuer: 'https://thrasio.oktapreview.com/oauth2/aus1xhdl3ax9VLqnT1d7',
  apiUrl: 'https://api.dev-gatekeeper.thrasio.com/',
};

class GlobalConfig {
  config = defaultConfig;

  notDefinedYet = true;

  get() {
    if (this.notDefinedYet) {
      throw new Error(
        'Global config has not been defined yet. Be sure to call the getter only after the config has been downloaded and set. Probable cause is accessing globalConfig in static context.',
      );
    } else {
      return this.config;
    }
  }

  set(value) {
    if (this.notDefinedYet) {
      this.config = value;
      this.notDefinedYet = false;
    } else {
      throw new Error(
        'Global config has already been defined and now has been called second time. This is probably not intended.',
      );
    }
  }
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = '/config.json';
